export default __webpack_public_path__ + "static/2264-eaf8809af6a60cc0e295f0109a9b96b0.gif";